export const hideButton = (filterListIsEmpty: boolean, openFilterSelector: boolean): boolean => {
  if (filterListIsEmpty) {
    return false;
  }

  return openFilterSelector;
};
